var defaultProps = {
    hex: '#c0c0c0',
    a: 1
}
export default {
    data() {
        return {
            filterOpen: false,
            previewMode: false,
            editingMode: true,
            department: null,
            step: 1,
            file: null,
            backgroundOpacity: 1,
            width: '100%',
            height: '100%',
            viewBox: '0 0 1280 720',
            colors: defaultProps,
            onChangeColorListener: null,
            showcolors: false,
            movetarget: null,
            activeItemIndex: null,
            drawingBorder: false,
            position: {x: null, y: null},
            forcedPosition: {x: null, y: null},
            polygonData: [],
            polygonItems: [], // OUTLINES FOR DEPARTMENTS
            currentBorder: {
                x: null,
                y: null,
                x2: null,
                y2: null
            },
            borders: [],
            items: [], // workflow placement
            tools: {
                squaresize: 8,
                min_height: 10
            },
        }
    },
    computed: {
        styleBasedOnStep() {
            if (this.step == 1) {
                return ''
            } else if (this.step == 2 && this.drawingBorder) {
                return 'cursor:none'
            } else {
                return ''
            }
        }
    },
    methods: {
        async handleResize() {

            let svg = document.getElementById('svg-floormap')
            let {height, width} = svg.getBoundingClientRect()
            this.height = height
            this.width = width
            // if(this.viewBox != null){
            // this.viewBox = '0 0 ' + width + ' ' + height
            // }
            let image = await this.autoFitSvgImage(this.image, 'svg-floormap')
            document.getElementById('floormap').setAttributeNS("http://www.w3.org/1999/xlink", "href", image)

        },
        async autoFitSvgImage(file, divId) {

            return new Promise((resolve, reject) => {
                var image = new Image();
                image.src = file;
                image.crossOrigin = 'anonymous';
                image.onload = () => {
                    var canvas = document.createElement('canvas');
                    let svg = document.getElementById(divId)
                    let {height, width} = svg.getBoundingClientRect()
                    height = 720
                    width = 1280
                    canvas.width = width;
                    canvas.height = height;

                    canvas.getContext('2d').drawImage(image, 0, 0, width, height);
                    var dataUrl = canvas.toDataURL('image/jpeg');

                    // self.$emit('imageData', dataUrl)
                    resolve(dataUrl)
                }
                image.onerror = () => reject(console.log(' file not loaded'))
            })

        },
        setSvgImage(event) {

            document.getElementById('floormap').setAttributeNS("http://www.w3.org/1999/xlink", "href", event)

        },
        setStep(event) {
            this.step = event
        },
        setFile(event) {
            this.file = event
        },
        getPolygonData(polygondata) {
            let polyString = ''
            _.each(polygondata, poly => {
                polyString += `${poly.x},${poly.y} `
            })
            return polyString
        },
        alreadyAdded(workflow) {
            return _.find(this.items, item => {
                return item.id === workflow.id
            })
        },
        onChange(val) {
            if (this.onChangeColorListener) {
                this.colors = val
                this.onChangeColorListener()
            }
        },
        toggleColor() {
            this.showcolors = !this.showcolors
        },
        addTextField() {
            this.items.push(this.createTextField())
        },
        setBorderDrawingMode() {
            this.drawingBorder = !this.drawingBorder

        },
        addRectangle(workflow) {
            if (!this.alreadyAdded(workflow)) {
                this.items.push(this.createRectangle(workflow))
            } else {
                let index = _.findIndex(this.items, item => {
                    return item.id == workflow.id
                })
                console.log(index)
                this.items.splice(index, 1)
                console.log(this.items)
            }
        },
        addEllipse() {
            this.items.push(this.createEllipse())
        },
        createTextField() {
            return {
                type: 'text',
                textAnchor: 'left',
                active: false,
                x: ((this.items.length + 2) % 20) * 20,
                y: ((this.items.length + 2) % 20) * 20,
                text: "ENTER TEXT",
                width: 400,
                height: 40,
                font: 'Arial',
                color: this.colors.hex || '#366696'
            }
        },
        createBorderRectangle() {
            return {
                type: 'rect',
                active: false,
                x: ((this.items.length + 2) % 20) * 20,
                y: ((this.items.length + 2) % 20) * 20,
                width: 75,
                height: 2,
                color: '#484848'
            }
        },
        createRectangle(workflow) {
            // let lastItem = _.last(this.items)
            this.items.map(item=>{
                item.active = false
                return item
            })
            return {
                type: 'rect',
                name: workflow.name,
                componentType: 'oee',
                id: workflow.id,
                active: true,
                x: ((this.items.length + 2) % 20) * 20,
                y: ((this.items.length + 2) % 20) * 20,
                width: 64,
                height: 97,
                color: this.colors.hex || '#cccccc'
            }
        },
        createEllipse() {
            return {
                type: 'ellipse',
                active: false,
                x: ((this.items.length + 2) % 20) * 20,
                y: ((this.items.length + 2) % 20) * 20,
                width: 120,
                height: 120,
                color: this.colors.hex || '#366696'
            }
        },
        onClickItem(event, item) {
            event.stopPropagation() //prevent parent from firing
            if (item.active) {
                return
            }
            // select item if not selected
            this.deactivateItems()
            item.active = true
            this.onChangeColorListener = function () {
                item.color = this.colors.hex
            }
            this.colors = defaultProps
            this.colors.hex = item.color
            this.activeItemIndex = this.items.indexOf(item)
        },
        moveUp() {
            if (this.activeItemIndex >= 0 && this.activeItemIndex < this.items.length) {
                var i = this.items[this.activeItemIndex]
                swapArrayElements(this.items, this.activeItemIndex, this.activeItemIndex + 1)
                this.activeItemIndex += 1
                this.$forceUpdate()
            }
        },
        moveDown() {
            if (this.activeItemIndex >= 0 && this.activeItemIndex >= 0) {
                var i = this.items[this.activeItemIndex]
                swapArrayElements(this.items, this.activeItemIndex, this.activeItemIndex - 1)
                this.activeItemIndex -= 1
                this.$forceUpdate()
            }
        },
        deactivateItems() {
            this.items.map(function (i) {
                if (i) i.active = false
            })
        },
        removeActiveItem() {
            this.items = this.items.filter((i) => i.active === false);
        },
        onMouseDownRegion(event, item) {

            if (item.active) {
                item.drag = {
                    type: 'MOVE',
                    x: item.x,
                    y: item.y,
                    mx: event.x,
                    my: event.y,
                }
            }
            this.movetarget = item
        },
        onMouseUp(event, element) {
            this.movetarget = null
        },
        onMouseDown(event) {
            if (this.drawingBorder) {
                // var dim = document.getElementById('svg-floormap').getBoundingClientRect();
                // var x = event.clientX - dim.left;
                // var y = event.clientY - dim.top;
                const domPoint = new DOMPointReadOnly(event.clientX, event.clientY)
                const pt = domPoint.matrixTransform(document.getElementById('svg-floormap').getScreenCTM().inverse())

                let {x, y} = pt
                if (this.forcedPosition.x) {
                    this.polygonData.push({
                        x: this.forcedPosition.x,
                        y: this.forcedPosition.y
                    })
                } else {
                    this.polygonData.push({
                        x: x,
                        y: y
                    })
                }

            }

        },
        onMouseMove(event) {
            var dim = document.getElementById('svg-floormap').getBoundingClientRect();
            var x = event.clientX - dim.left;
            var y = event.clientY - dim.top;
            const domPoint = new DOMPointReadOnly(event.clientX, event.clientY)
            const pt = domPoint.matrixTransform(document.getElementById('svg-floormap').getScreenCTM().inverse())

            x = pt.x
            y = pt.y
            this.position = {x, y}
            if (this.polygonData.length) {
                let curX = this.polygonData[this.polygonData.length - 1].x
                let curY = this.polygonData[this.polygonData.length - 1].y
                if (Math.abs(x - curX) > Math.abs(y - curY)) {
                    this.forcedPosition = {x: x, y: curY}
                } else {
                    this.forcedPosition = {x: curX, y: y}
                }
            }


            if (this.movetarget == null) return
            var item = this.movetarget
            var t = this.tools

            if (item.active && item.drag != undefined) {
                if (item.drag.type == 'MOVE') {
                    const domPoint = new DOMPointReadOnly(event.clientX, event.clientY)

                    const pt = domPoint.matrixTransform(document.getElementById('svg-floormap').getScreenCTM().inverse())
                    item.x =   Math.round(pt.x / 5) * 5
                    item.y =  Math.round(pt.y / 5) * 5
                    // item.x = pt.x //event.x - item.drag.mx + item.drag.x;
                    // item.y =  pt.y //event.y - item.drag.my + item.drag.y;
                }
                if (item.drag.type == 'SCALE') {
                    if (item.drag.handleID == '1') {
                        // TL resize handler
                        item.x = Math.min(event.x - item.drag.mx + item.drag.x, item.drag.x + (item.drag.w - t.min_height))
                        item.y = Math.min(event.y - item.drag.my + item.drag.y, item.drag.y + (item.drag.h - t.min_height)) // with y constraint
                        item.width = Math.max(item.drag.w - event.x + item.drag.mx, t.min_height)
                        item.height = Math.max(item.drag.h - event.y + item.drag.my, t.min_height)
                    }
                    if (item.drag.handleID == '3') {
                        // TR resize handler
                        item.y = Math.min(event.y - item.drag.my + item.drag.y, item.drag.y + (item.drag.h - t.min_height)) // with y constraint
                        item.width = Math.max(item.drag.w + event.x - item.drag.mx, t.min_height);
                        item.height = Math.max(item.drag.h - event.y + item.drag.my, t.min_height)
                    }
                    if (item.drag.handleID == '7') {
                        // BL
                        item.x = Math.min(event.x - item.drag.mx + item.drag.x, item.drag.x + (item.drag.w - t.min_height))
                        item.width = Math.max(item.drag.w - event.x + item.drag.mx, t.min_height)
                        item.height = Math.max(item.drag.h + event.y - item.drag.my, t.min_height)
                    }
                    if (item.drag.handleID == '9') {
                        // BR
                        item.width = Math.max(item.drag.w + event.x - item.drag.mx, t.min_height);
                        item.height = Math.max(item.drag.h + event.y - item.drag.my, t.min_height);
                    }
                }
            }
        },
        onKeyUp(event) {
            if (event.key === 'Delete') {
                this.removeActiveItem()
            }
            return event.preventDefault();
        },
        onKeyDown(event) {

            if (event.ctrlKey && event.key === "z") {
                if (this.drawingBorder) {
                    this.polygonData.pop()
                }
            }
        },
        onMouseDownHandles(event, item) {
            var handleID = event.target.getAttribute('data-handleid');
             item.drag = {
                x: item.x,
                y: item.y,
                mx: event.x,
                my: event.y,
                w: item.width,
                h: item.height,
                type: 'SCALE',
                handleID: handleID
            }

            this.movetarget = item
        },
        textAlign(val) {
            var i = this.items[this.activeItemIndex]
            if (i && i.type == 'text') {
                i.textAnchor = val;

                this.$forceUpdate()
            }

        },
        getTextXPos(item) {
            if (item.textAnchor == 'middle') return item.width / 2
            if (item.textAnchor == 'end') return item.width
            return 0
        },
        resetDrawing() {
            this.setDepartments([])
            this.polygonItems = []
            this.polygonData = []
            this.forcedPosition = {x: null, y: null}
        }
    },
    watch: {
        step(newV) {
            this.drawingBorder = false
            if (newV == 2) {
                this.drawingBorder = true
                this.editingMode = true
            }
        },
        backgroundOpacity(newV) {
            document.getElementById('floormap').style.opacity = newV;
        }
    },
    created() {
    },
    mounted() {
        window.addEventListener('keyup', this.onKeyUp);
        window.addEventListener('keydown', this.onKeyDown);
        // new ResizeObserver(this.handleResize).observe(document.getElementById('svg-floormap'))
        // const svgImage = document.getElementById("svg-floormap");
        // const svgContainer = document.getElementById("svgContainer");
        //
        // var viewBox = {x:0,y:0,w:svgImage.clientWidth,h:svgImage.clientHeight};
        // svgImage.setAttribute('viewBox', `${viewBox.x} ${viewBox.y} ${viewBox.w} ${viewBox.h}`);
        // const svgSize = {w:svgImage.clientWidth,h:svgImage.clientHeight};
        // var isPanning = false;
        // var startPoint = {x:0,y:0};
        // var endPoint = {x:0,y:0};
        // var scale = 1;
        //
        // svgContainer.onmousewheel = function(e) {
        //   e.preventDefault();
        //   var w = viewBox.w;
        //   var h = viewBox.h;
        //   var mx = e.offsetX;//mouse x
        //   var my = e.offsetY;
        //   var dw = w*Math.sign(e.deltaY)*0.05;
        //   var dh = h*Math.sign(e.deltaY)*0.05;
        //   var dx = dw*mx/svgSize.w;
        //   var dy = dh*my/svgSize.h;
        //   viewBox = {x:viewBox.x+dx,y:viewBox.y+dy,w:viewBox.w-dw,h:viewBox.h-dh};
        //   scale = svgSize.w/viewBox.w;
        //   zoomValue.innerText = `${Math.round(scale*100)/100}`;
        //   svgImage.setAttribute('viewBox', `${viewBox.x} ${viewBox.y} ${viewBox.w} ${viewBox.h}`);
        // }
        //
        //
        // svgContainer.onmousedown = function(e){
        //   isPanning = true;
        //   startPoint = {x:e.x,y:e.y};
        // }
        //
        // svgContainer.onmousemove = function(e){
        //   if (isPanning){
        //     endPoint = {x:e.x,y:e.y};
        //     var dx = (startPoint.x - endPoint.x)/scale;
        //     var dy = (startPoint.y - endPoint.y)/scale;
        //     var movedViewBox = {x:viewBox.x+dx,y:viewBox.y+dy,w:viewBox.w,h:viewBox.h};
        //     svgImage.setAttribute('viewBox', `${movedViewBox.x} ${movedViewBox.y} ${movedViewBox.w} ${movedViewBox.h}`);
        //   }
        // }
        //
        // svgContainer.onmouseup = function(e){
        //   if (isPanning){
        //     endPoint = {x:e.x,y:e.y};
        //     var dx = (startPoint.x - endPoint.x)/scale;
        //     var dy = (startPoint.y - endPoint.y)/scale;
        //     viewBox = {x:viewBox.x+dx,y:viewBox.y+dy,w:viewBox.w,h:viewBox.h};
        //     svgImage.setAttribute('viewBox', `${viewBox.x} ${viewBox.y} ${viewBox.w} ${viewBox.h}`);
        //     isPanning = false;
        //   }
        // }
        //
        // svgContainer.onmouseleave = function(e){
        //   isPanning = false;
        // }
    }

}


var swapArrayElements = function (arr, indexA, indexB) {
    var temp = arr[indexA];
    arr[indexA] = arr[indexB];
    arr[indexB] = temp;
};